import { render, staticRenderFns } from "./PopupSave.vue?vue&type=template&id=28ff93ee&scoped=true"
import script from "./PopupSave.vue?vue&type=script&lang=js"
export * from "./PopupSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff93ee",
  null
  
)

export default component.exports